module.exports = "/assets/career/team/marta.png?LfJua3O";